<script setup lang="ts">
import type { BuildingBlockType } from '@/stores/buildingBlock'

const open = defineModel<boolean>({ required: true })

const emit = defineEmits<{
  select: [blockType: BuildingBlockType]
}>()

const BLOCK_TYPE_OPTIONS: {
  value: BuildingBlockType
  title: string
  description: string
}[] = [
  {
    value: 'material',
    title: 'Material',
    description:
      'Use the current building block process and add material rows from the selected database.'
  },
  {
    value: 'equipment',
    title: 'Equipment',
    description: 'Add equipment rows directly and define their impact with activities.'
  }
]

const onSelect = (blockType: BuildingBlockType) => {
  emit('select', blockType)
}
</script>

<template>
  <v-dialog v-model="open" max-width="560">
    <v-card class="pa-2">
      <v-card-title class="text-h6">Choose building block type</v-card-title>
      <v-card-subtitle>
        Material rows come from the database. Equipment rows are named by you and get their impact
        from activities.
      </v-card-subtitle>

      <v-card-text class="pt-4">
        <v-row>
          <v-col v-for="option in BLOCK_TYPE_OPTIONS" :key="option.value" cols="12" md="6">
            <v-card variant="outlined" class="block-type-card" @click="onSelect(option.value)">
              <v-card-title class="text-subtitle-1">{{ option.title }}</v-card-title>
              <v-card-text class="text-body-2">
                {{ option.description }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" variant="text" @click="open = false"> Cancel </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.block-type-card {
  cursor: pointer;
  min-height: 150px;
}
</style>
